import React, { useState } from "react";
import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import { EquipmentList } from "./EquipmentList";

const EquipmentPage = () => {
  return (
    <DashboardLayout>
      <EquipmentList />
    </DashboardLayout>
  );
};

export default EquipmentPage;
